'use strict'

module.exports = footnote

var footnoteReference = require('./footnote-reference')

/* Transform an inline footnote. */
function footnote(h, node) {
  var identifiers = []
  var identifier = 1
  var footnotes = h.footnotes
  var length = footnotes.length
  var index = -1

  while (++index < length) {
    identifiers[index] = footnotes[index].identifier
  }

  while (identifiers.indexOf(String(identifier)) !== -1) {
    identifier++
  }

  identifier = String(identifier)

  footnotes.push({
    type: 'footnoteDefinition',
    identifier: identifier,
    children: [{type: 'paragraph', children: node.children}],
    position: node.position
  })

  return footnoteReference(h, {
    type: 'footnoteReference',
    identifier: identifier,
    position: node.position
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/footnote.js
// module id = 891
// module chunks = 95715928098905 168707334958949